import { useAtom } from 'jotai'
import { useTranslation } from 'react-i18next'

import { Box } from '@/components/ui/box'
import { Radio, RadioGroup } from '@/components/ui/radio'
import { Stack } from '@/components/ui/stack'
import { Text } from '@/components/ui/typography'
import { sharepointPermisionAtom } from '@/store/tasksApprovals/detailsDrawer'
import { IField } from '@/types/tasksApprovals'

const RequestedPermission = ({ item }: { item: IField }) => {
    const { t } = useTranslation()
    const [value, setValue] = useAtom(sharepointPermisionAtom)

    // TODO - variant="gigiOutline" on both Radio components
    // TODO - check if we need '' as a fallback when radio group value changes
    return (
        <Box py="8px" px="24px">
            <Text fontSize={12} pb="4px">
                {item.name}
            </Text>
            <RadioGroup onValueChange={(e) => setValue(e.value as string)} value={value} mt="8px">
                <Stack direction="row" gap="32px">
                    <Radio value="view">{t('tasksApprovals.sharepointDrawer.view')}</Radio>
                    <Radio value="edit">{t('tasksApprovals.sharepointDrawer.edit')}</Radio>
                </Stack>
            </RadioGroup>
        </Box>
    )
}

export default RequestedPermission
